<template>
    <page>
        <module :title="id ? '编辑健康活动' : '新建健康活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="input" label="活动标题"  name="title" maxlength="50" word="标题最多输入50个字符" required></c-form-item>
                    <c-form-item type="datetime" label="报名截止时间" name="apply_deadline" required></c-form-item>
                    <c-form-item type="number" label="报名人数上限" decimal="0" :limit="[1,999999]" name="user_count"  input-unit="人" ></c-form-item>
                    <c-form-item type="image" label="活动封面图" name="cover_image" file-word="图片尺寸建议800X800，格式支持jpg、png、gif，单个图片大小建议不超过3MB" required></c-form-item>
                    <c-form-item type="image" label="活动内容图片" name="content_images" limit="10" required
                                 file-word="最多上传10张图片；图片尺寸建议800X800，格式支持jpg、png、gif，单个图片大小建议不超过3MB"></c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button v-show="editFlag" power="b_offline_activity_edit" size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
    export default {
        name: 'offline_activity_edit',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                activityNoticeTime: 0,
                activityNotice: -1,
                activityNoticeOptions: [{
                  name: '立即预告',
                  value: 0
                },{
                  name: '不预告',
                  value: -1
                },{
                    name: '提前预告',
                    value: 1
                }],
                activity_id: '',
                sale_price: 0,
                new_user_limit: '',
                min_price_order: '',
                productList: [],
                editFlag: true,
                purchase_limit:1
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/offineActivity/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                    }
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                list.forEach(item=>{
                    item.state = 1;
                    item.min_price_order = 1;
                })
                //检查商品时间是否和其他活动重叠
                this.productList = this.productList.concat(list);
            },
            setLimit() {
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.sale_price = 0;
                this.$refs.limitDialog.open();

            },
            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/offineActivity/edit' : '/offineActivity/add',
                    rule: {
                        title: '请填写活动标题',
                        apply_deadline: '请填写活动报名截止时间',
                        user_count: '请填写活动报名人数上限',
                        cover_image: '请上传活动封面图',
                        content_images: '请上传活动内容图'
                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.content_images = data.content_images.join(',');//列表转字符串
                        return data;
                    },

                    success: (data,obj) => {
                        this.$message({
                            text: "保存成功",
                        });
                        this.$bus.$emit('offineActivityList.update');
                        this.redirectTo('/offline_activity');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>